import { useCallback, useState } from 'react';

import { Modal } from 'antd';

import { MODAL_FOOTER_BUTTON_SIZE, MODAL_WIDTHS } from '@/shared/lib/constants';
import { Button } from '@/shared/ui/Button';
import type { IconName } from '@/shared/ui/Icon';
import { Icon } from '@/shared/ui/Icon';

import styles from '@/features/connectors/ui/_internal/connectorModal.module.css';

type ActivationMode = 'activate' | 'deactivate';

const ACTIVATION_CONFIG: Record<ActivationMode, { icon: IconName; confirmLabel: string }> = {
  activate: {
    icon: 'light-on',
    confirmLabel: '확인',
  },
  deactivate: {
    icon: 'light',
    confirmLabel: '확인',
  },
} as const;

type ActivationModalProps = {
  open: boolean;
  mode: ActivationMode;
  selectedCount: number;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

export const ActivationModal = ({ open, mode, selectedCount, onConfirm, onCancel }: ActivationModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const config = ACTIVATION_CONFIG[mode];

  const handleConfirm = useCallback(async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  }, [onConfirm]);

  const footer = (
    <>
      <Button variant="outlined" color="standard" disabled={isLoading} onClick={onCancel} {...MODAL_FOOTER_BUTTON_SIZE}>
        취소
      </Button>
      <Button
        variant="filled"
        color="standard"
        loading={isLoading}
        onClick={handleConfirm}
        {...MODAL_FOOTER_BUTTON_SIZE}>
        {config.confirmLabel}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      centered
      closable={false}
      title={null}
      footer={footer}
      width={MODAL_WIDTHS.CONFIRM_ALERT}
      onCancel={onCancel}>
      <div className={styles.popupBody}>
        <div className={styles.popupIcon}>
          <Icon name={config.icon} size={32} />
        </div>
        <p className={styles.popupDescription}>{selectedCount}개의 Data Source Connector 상태를 변경합니다.</p>
        <p className={styles.popupDescription}>Connector 목록에서 정상 동작 여부를 확인하세요.</p>
      </div>
    </Modal>
  );
};
